import overlayApi from "solid-overlays";

import ModalSheetLayout from "@repo/ui/overlays/ModalSheetLayout";
import UObject from "@repo/utils/UObject";

import { track } from "~/analytics/client.js";

const overlayByPath = Object.assign(
  UObject.trimKeys(
    // prettier-ignore
    import.meta.glob("./**/*.tsx") as unknown as {
/* GENERATED */ "./Document.tsx": () => Promise<typeof import("./Document.tsx")>,
/* GENERATED */ "./account/CallUs.tsx": () => Promise<typeof import("./account/CallUs.tsx")>,
/* GENERATED */ "./account/ChangeAddress.tsx": () => Promise<typeof import("./account/ChangeAddress.tsx")>,
/* GENERATED */ "./account/ChangeEmail.tsx": () => Promise<typeof import("./account/ChangeEmail.tsx")>,
/* GENERATED */ "./account/ChangePassword.tsx": () => Promise<typeof import("./account/ChangePassword.tsx")>,
/* GENERATED */ "./account/ChangePhone.tsx": () => Promise<typeof import("./account/ChangePhone.tsx")>,
/* GENERATED */ "./account/GetHelp.tsx": () => Promise<typeof import("./account/GetHelp.tsx")>,
/* GENERATED */ "./address/InvalidAddress.tsx": () => Promise<typeof import("./address/InvalidAddress.tsx")>,
/* GENERATED */ "./credit/AboutErs.tsx": () => Promise<typeof import("./credit/AboutErs.tsx")>,
/* GENERATED */ "./creditAccount/Close.tsx": () => Promise<typeof import("./creditAccount/Close.tsx")>,
/* GENERATED */ "./creditAccount/CloseConfirmed.tsx": () => Promise<typeof import("./creditAccount/CloseConfirmed.tsx")>,
/* GENERATED */ "./creditAccount/CloseSurvey.tsx": () => Promise<typeof import("./creditAccount/CloseSurvey.tsx")>,
/* GENERATED */ "./creditAccount/ExplainCreditLimit.tsx": () => Promise<typeof import("./creditAccount/ExplainCreditLimit.tsx")>,
/* GENERATED */ "./creditAccount/ExplainCreditUtilization.tsx": () => Promise<typeof import("./creditAccount/ExplainCreditUtilization.tsx")>,
/* GENERATED */ "./onboarding/AcceptableIdentityDocuments.tsx": () => Promise<typeof import("./onboarding/AcceptableIdentityDocuments.tsx")>,
/* GENERATED */ "./onboarding/AttributionSurvey.tsx": () => Promise<typeof import("./onboarding/AttributionSurvey.tsx")>,
/* GENERATED */ "./onboarding/DownloadApp.tsx": () => Promise<typeof import("./onboarding/DownloadApp.tsx")>,
/* GENERATED */ "./onboarding/ItinExplanation.tsx": () => Promise<typeof import("./onboarding/ItinExplanation.tsx")>,
/* GENERATED */ "./onboarding/RetryNotice.tsx": () => Promise<typeof import("./onboarding/RetryNotice.tsx")>,
/* GENERATED */ "./payments/AddPaymentMethod.tsx": () => Promise<typeof import("./payments/AddPaymentMethod.tsx")>,
/* GENERATED */ "./payments/Autopay.tsx": () => Promise<typeof import("./payments/Autopay.tsx")>,
/* GENERATED */ "./payments/DisableAutopayConfirmation.tsx": () => Promise<typeof import("./payments/DisableAutopayConfirmation.tsx")>,
/* GENERATED */ "./payments/MakePayment.tsx": () => Promise<typeof import("./payments/MakePayment.tsx")>,
/* GENERATED */ "./payments/PayInFull.tsx": () => Promise<typeof import("./payments/PayInFull.tsx")>,
/* GENERATED */ "./payments/PaymentMethodAdded.tsx": () => Promise<typeof import("./payments/PaymentMethodAdded.tsx")>,
/* GENERATED */ "./payments/PaymentMethodDetails.tsx": () => Promise<typeof import("./payments/PaymentMethodDetails.tsx")>,
/* GENERATED */ "./payments/RemovePaymentMethod.tsx": () => Promise<typeof import("./payments/RemovePaymentMethod.tsx")>,
/* GENERATED */ "./payments/SelectPaymentMethod.tsx": () => Promise<typeof import("./payments/SelectPaymentMethod.tsx")>,
/* GENERATED */ "./payments/Thanks.tsx": () => Promise<typeof import("./payments/Thanks.tsx")>,
/* GENERATED */ "./shopping/ProductOverview.tsx": () => Promise<typeof import("./shopping/ProductOverview.tsx")>,
/* GENERATED */ "./subscriptions/ConfirmPlanChange.tsx": () => Promise<typeof import("./subscriptions/ConfirmPlanChange.tsx")>,
/* GENERATED */ "./subscriptions/PremiumUpgrade.tsx": () => Promise<typeof import("./subscriptions/PremiumUpgrade.tsx")>,
/* GENERATED */ "./subscriptions/ToggleAutoRenew.tsx": () => Promise<typeof import("./subscriptions/ToggleAutoRenew.tsx")>,
/* GENERATED */ "./support/SatisfactionGuarantee.tsx": () => Promise<typeof import("./support/SatisfactionGuarantee.tsx")>
},
    "./",
    ".tsx"
  ),
  UObject.trimKeys(
    // prettier-ignore
    import.meta.glob("../**/*.overlay.tsx") as unknown as {

},
    "../",
    ".overlay.tsx"
  )
);

export type OverlayKey = keyof typeof overlayByPath;

export const {
  OverlaysProvider,
  useOverlay,
  useOverlayBackdrop,
  useOverlayLayout,
  useOverlaysBase,
  useOverlaysController,
} = overlayApi(overlayByPath, {
  DefaultLayout: ModalSheetLayout,
}).create({
  hooks: {
    open(key) {
      track.overlay("impression", { key });
    },
  },
});
